export const Getters = {
    lastTimestamp: state => {
        if (!state.lastTimestamp) {
            return 0;
        }
        return (state.lastTimestamp - 1);
    },
}
